import type { MutationHookOptions } from '@apollo/client'
import {
  CreateTrainingMembershipsDocument,
  CreateTrainingMembershipsMutation,
  CreateTrainingMembershipsMutationVariables,
  TrainingParticipantsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  CreateTrainingMembershipsMutation,
  CreateTrainingMembershipsMutationVariables
>
export const useCreateTrainingMemberships = (options?: Options) => {
  const [createTrainingMemberships, { loading }] = useMutation(CreateTrainingMembershipsDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.bulkCreateTrainingsTrainingMembership,
  })

  return {
    loading,
    createTrainingMemberships(variables: CreateTrainingMembershipsMutationVariables) {
      return createTrainingMemberships({
        variables,
        refetchQueries: [TrainingParticipantsDocument],
      })
    },
  }
}
